import { NumberInput, required } from "react-admin";
import { FcrDEngagementFields } from "../shared/initialFields";

const TestFcrDInitialFields = () => {
  return (
    <>
      <NumberInput source={FcrDEngagementFields.highDroop} defaultValue={0.1} validate={[required()]} />
      <NumberInput source={FcrDEngagementFields.lowDroop} defaultValue={1.25} validate={[required()]} />
      <NumberInput source={FcrDEngagementFields.oneHourTestCapacity} defaultValue={1.04} validate={[required()]} />
    </>
  );
};

export default TestFcrDInitialFields;
